;(function($){
    // Global variables
    var uploader;
    let $hb_file_queue = [];
    let $hb_file_queue_state = "empty";
    let $pending_uploads = {
        _uploads: [],
        add: function (id) {
            $pending_uploads._uploads.push(id);
        },
        remove: function (id) {
            for (var i=0; i < $pending_uploads._uploads.length; i++) {
                if ($pending_uploads._uploads[i]==id) {
                    $pending_uploads._uploads.splice(i, 1);
                }
            }
        },
        has_pending_uploads: function () {
            return $pending_uploads._uploads!=0;
        }
    };

    function handleAutoSaveFiles({xhr, resp, filesize}) {
        const token = window.location.pathname.split('/').pop();
        const localString = `autosave/comment/${token}`;
        const autoSavedComment = localStorage.getItem(localString);
        let autoSavedCommentObj;

        if(autoSavedComment) {
            autoSavedCommentObj = JSON.parse(autoSavedComment);
        } else {
            autoSavedCommentObj = {
                message: '',
                files: []
            }
        }

        if(!autoSavedCommentObj.files) {
            autoSavedCommentObj.files = []
        }

        autoSavedCommentObj.files.push({
            id: xhr.id,
            location: resp.location,
            thumbnail_location: resp.thumbnail_location,
            file_name: xhr.file_name,
            filesize,
            checked: true
        })
        localStorage.setItem(localString, JSON.stringify(autoSavedCommentObj));
    }

    function handleAutoSaveFilesV2({xhr, resp, filesize}) {
        const token = window.location.pathname.split('/').pop();
        const localString = `autosave/comment/${token}`;
        const autoSavedComment = localStorage.getItem(localString);
        let autoSavedCommentObj;

        if(autoSavedComment) {
            autoSavedCommentObj = JSON.parse(autoSavedComment);
        } else {
            autoSavedCommentObj = {
                message: '',
                files: []
            }
        }

        if(!autoSavedCommentObj.files) {
            autoSavedCommentObj.files = []
        }

        autoSavedCommentObj.files.push({
            id: xhr.id,
            token: resp.token,
            file_name: xhr.file_name,
            filesize,
            checked: true
        })
        localStorage.setItem(localString, JSON.stringify(autoSavedCommentObj));
    }

    $.fn.html5_upload = function(opts) {
        var has_file_api_support = typeof(FileReader) != 'undefined';

        if (!has_file_api_support) {
            // For non-supported we use standard
            // file inputs
            return;
        }
        var opts = $.extend({
            file_uploads_url: ''
        }, opts);

        this.each(function() {
            var the_form = $(this);
            var submit_button = the_form.find('input[type=submit]');
            submit_button.each(function(){
                $(this).attr('title', $(this).val());
            });

            // change the style of supported file attachment
            the_form.find('.attachment').each(function(){
                $(this).addClass('attachment-file-reader-supported');
                $(this).parent().find('.attach-link').show();
            });

            /* file uploads ... */
            function file_uploader() {}

            file_uploader.prototype.upload_files = function(files_list) {
                for (var i=0; i < files_list.length; i++) {
                    var file_ext = files_list[i].name.replace(/.*\./, '').toLowerCase();
                    if ($.inArray(file_ext, disallowed_extensions)!=-1) {
                        alert(file_ext + ' files are not suppported. "' + files_list[i].name + '" skipped. ');
                    } else if (files_list[i].size > max_allowed_filesize) {
                        alert('"' + files_list[i].name + "\" file exceeds the attachment size limit. Sorry.")
                    } else {
                        upload_file_html5_files_api(files_list[i]);
                    }
                }
                send_queue();
            }

            function upload_file_html5_files_api(file) {
                let id = Math.random().toString().replace('.', '');
                var repr = $('<div class="file-row" id="file_' + id + '"><span class="filename">' + file.name + '</span> <span class="filesize">' + nice_file_size(file.size) + '</span><div class="progressbar"><div class="progressbar-inner"><span class="progressbar-inner__number">&nbsp;</span></div></div></div>');
                var xhr = new XMLHttpRequest();

                // xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                submit_button.prop('disabled', true).addClass('disabled').val('Please wait...');

                var uploaded_files = the_form.find('.uploaded-files');
                if (uploaded_files.length) {
                    uploaded_files.show().append(repr);
                } else {
                    return;
                }

                xhr.repr = repr;
                xhr.id = id;
                xhr.file_name = file.name;
                xhr.upload.addEventListener("progress", function(e) {
                    if (e.lengthComputable) {
                        var percentage = Math.round((e.loaded * 100) / e.total);
                        xhr.repr.find('.progressbar-inner').css('width', percentage + '%')
                        xhr.repr.find('.progressbar-inner .progressbar-inner__number').html( percentage + '%' );
                    }
                }, false);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState == 4) {

                        $pending_uploads.remove(xhr.id);
                        xhr.repr.find('.progressbar').hide();
                        if (xhr.status != 200)  {
                            xhr.repr.remove();
                            alert("Sorry, error occured -- try again later. ");
                            file_proceesed();
                            return;
                        }

                        var resp;
                        try {
                            resp = JSON.parse(xhr.responseText);
                        } catch (e) {
                            xhr.repr.remove();
                            alert("Sorry, error occured -- try again later.");
                            file_proceesed();
                            return;
                        }
                        xhr.repr.find('.filename').wrap('<span class="wrap"></span>');

                        var include_check = $('<label for="files[' + xhr.id + '][token]" class="field-checkbox"> <input type="checkbox" checked="checked" class="insert-check c" id="files[' + xhr.id + '][token]"  name="files[' + xhr.id + '][token]" value="' + resp.token + '" /> <span></span> </label>')
                        include_check.insertBefore(xhr.repr.find('span.wrap'));

                        $('<input type="hidden" name="files[' + xhr.id + '][original_name]" value="' + xhr.file_name + '" />').insertBefore(xhr.repr.find('span.wrap'));

                        const hasEnabledHistory = uploaded_files.data('enable-history');
                        if(hasEnabledHistory) {
                            handleAutoSaveFilesV2({
                                xhr,
                                resp,
                                filesize: nice_file_size(file.size)
                            });
                        }

                        file_proceesed();
                    }
                }
                xhr.file = file;
                $hb_file_queue.push(xhr);
            }

            function send_queue() {
                $(document).bind('file_proceesed', function () {
                    if ($hb_file_queue.length!=0) {
                        //console.log("next file ... ");
                        send_file($hb_file_queue.shift());
                    } else {
                        $hb_file_queue_state = "empty";
                        //console.log("queue done ");
                        enable_submit_button();
                    }
                });
                if ($hb_file_queue_state=="empty") {
                    send_file($hb_file_queue.shift());
                    $hb_file_queue_state = "uploading";
                }
            }

            // file is now proceesed
            function file_proceesed(){
                $(document).trigger("file_proceesed");
            }

            function send_file(xhr) {
                xhr.open("POST", opts.file_uploads_url + '?original_name=' + escape(xhr.file.name));
                xhr.setRequestHeader('X-CSRF-TOKEN', document.querySelector('head meta[name="csrf-token"]')?.content);
                var file = xhr.file;
                try {
                    var formData = new FormData();
                    formData.append('file', file);
                    xhr.send(formData);
                } catch(e) {
                    // FormData object is not supported -- Firefox 3.6 doesn't support it.
                    // So we have to build the HTTP message ourselves. Yuck!
                    var boundary = "AJAX-----------------------" + (new Date).getTime();
                    var contentType = "multipart/form-data; boundary=" + boundary;
                    xhr.setRequestHeader("Content-Type", contentType);

                    var CRLF = "\r\n";

                    var field_name = "file";
                    var file_name = file.name;

                    /*
                     * Content-Disposition header contains name of the field
                     * used to upload the file and also the name of the file as
                     * it was on the user's computer.
                     */
                    file_part = 'Content-Disposition: form-data; ';
                    file_part += 'name="' + field_name + '"; ';
                    file_part += 'filename="'+ file_name + '"' + CRLF;

                    /*
                     * Content-Type header contains the mime-type of the file
                     * to send. Although we could build a map of mime-types
                     * that match certain file extensions, we'll take the easy
                     * approach and send a general binary header:
                     * application/octet-stream
                     */
                    file_part += "Content-Type: application/octet-stream";
                    file_part += CRLF + CRLF; // marks end of the headers part

                    /*
                     * File contents read as binary data, obviously
                     */
                    file_part += file.getAsBinary() + CRLF;

                    /* Build the body ... */
                    request = "--" + boundary + CRLF;
                    request += file_part;
                    request += "--" + boundary + "--" + CRLF;

                    xhr.sendAsBinary(request);
                }
                $pending_uploads.add(xhr.id);
            }

            function enable_submit_button() {
                submit_button.removeClass('disabled').prop('disabled', false);
                submit_button.each(function(){
                    $(this).val( $(this).attr('title') );
                });
            }

            uploader = new file_uploader();

            the_form.find('.attachment').change(function () {
                uploader.upload_files(this.files);
            });

            /*
                HTML5 drap and drop API is brain damaged. I didn't find any better
                way to achieve gmail-like functionality that works in Firefox and Chrome
            */

            // This fragment is responsible for closing the dropper divs once they're
            // not needed. There isn't other way to catch this event as dragleave
            // doesn't work as expected(like mouseleave).
            var _previous_dragover = null;
            window.addEventListener("dragover", function(event) {
                if (_previous_dragover!==null) {
                    clearTimeout(_previous_dragover);
                }
                _previous_dragover = setTimeout(function () {
                    the_form.find('.drop-here').hide();
                    _previous_dragover = null;
                }, 150);
            }, false);

            // drag start and dragend events are triggered only when the dragged element
            // is part part of the DOM. They're not called for files dragging. I'm using
            // this as I dind't find way to differentiate the event for DOM elements and
            // files events
            var _disable_file_drops = false;
            window.addEventListener("dragstart", function(event) {
                _disable_file_drops = true;
            }, 1);
            window.addEventListener("dragend", function(event) {
                _disable_file_drops = false;
            }, 1);

            // Show the dropper only when files are dragged
            window.addEventListener("dragenter", function(event) {
                if (!_disable_file_drops) {
                    the_form.find('.drop-here').show();
                }
            }, false);

            $(window).bind("dragover", function(event) {
                event.preventDefault();
            });
            the_form.find('.drop-here').get(0).addEventListener("dragover", function(event) {
                event.preventDefault();
            }, true);


            window.addEventListener("drop", function(event) {
                event.preventDefault();
                the_form.find('.drop-here').hide();
            }, true);

            the_form.find('.drop-here').each(function () {
                this.addEventListener("drop", function(event) {
                    event.preventDefault();
                    uploader.upload_files(event.dataTransfer.files);
                    the_form.find('.drop-here').hide();
                }, true);
            });

            the_form.bind('reset', function() {
                $('.uploaded-files', this).html('');
                $(this).find('.attachment').prop('disabled', false);
            });

            the_form.bind('enable_attachments', function(){
                $(this).find('.attachment').prop('disabled', false);
            });

            the_form.submit(function() {
                if (the_form.data("not-valid")) {
                    the_form.removeData("not-valid");
                    return false;
                }
                if( $pending_uploads.has_pending_uploads() ) {
                    alert('Please wait, the files are not yet uploaded!');
                    return false;
                } else {
                    // remove the file field from the POST -- assuming that everything
                    // above went fine the files should be sent through xhr already.
                    $(this).find('.attachment').prop('disabled', true);
                }
            });
        });
    }

    function appendFiles(files) {
        for(var i = 0; i < files.length; i++) {
            var file = files[i];
            var fileID = Math.random().toString().replace('.', '');
            var repr = $('<div class="file-row" id="file_' + fileID + '"><span class="filename">' + file.name + '</span> <span class="filesize">' + nice_file_size(file.bytes) + '</span></div>');
        }
    }

    function nice_file_size(bytes) {
        var kb = Math.round(Math.round(bytes/1024*100000)/100000);
        var mb = Math.round(Math.round(bytes/1048576*100000)/100000);
        if (mb) {
            return mb + "MB";
        }
        return kb + "KB";
    }
})(jQuery);
